<script>
import { mapState, mapActions } from "vuex";
import Pagination from "@/components/_Shared/Pagination";
import PreloaderTable from "@/components/_Shared/PreloaderTable";
import dateMixin from "@/mixins/dateMixin";
import Sent from "@/components/Notifications/List/Sent";
import Scheduled from "@/components/Notifications/List/Scheduled";
import NewSend from "../Send/Index";

export default {
  title: "Notifications",
  mixins: [dateMixin],

  components: {
    NewSend,
    Sent,
    Scheduled
  },

  computed: {
    ...mapState("notifications", ["loader", "search", "notificationType"]),
    search: {
      get() {
        return this.$store.state.notifications.search;
      },
      set(value) {
        this.$store.dispatch("notifications/setText", value);
      }
    }
  },

  methods: {
    ...mapActions("notifications", ["setSearch", "setNotificationType"]),
    submitSearch(text) {
      try {
        this.setSearch(text);
      } catch (e) {
        this.$toast.error(e);
      }
    }
  },

  mounted() {
    this.setNotificationType("sent");
  }
};
</script>

<template>
  <div>
    <v-card class="mb-20 px-5" flat>
      <v-layout align-center justify-space-between row fill-height wrap>
        <v-btn-toggle mandatory borderless color="secondary">
          <v-btn @click="setNotificationType('sent')">
            <span>enviadas</span>
            <v-icon>mdi-calendar-check</v-icon>
          </v-btn>

          <v-btn @click="setNotificationType('scheduled')">
            <v-icon>mdi-calendar-clock</v-icon>
            <span>agendadas</span>
          </v-btn>
        </v-btn-toggle>
        <div>
          <v-text-field
            v-validate="'min:3'"
            name="search"
            :error="errors.has('search')"
            :error-messages="errors.first('search')"
            :value="search"
            @keyup.enter="submitSearch($event.target.value)"
            append-icon="search"
            label="Buscar..."
            hide-details
          ></v-text-field>
        </div>
      </v-layout>
    </v-card>
    <scheduled v-if="notificationType == 'scheduled'" />
    <sent v-else />
  </div>
</template>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Notifications/List/List.vue